export const NOT_AVAILABLE = 'N/A';
export const UNKNOWN = 'UNKNOWN';
export const TimeFrame = 'timeFrame';
export const CompartmentDockStructure = 'compartmentDockStructure';
